export enum Environment {
  DEV = 'dev',
  STAGING = 'staging',
  PROD = 'prod',
  LOCALHOST = 'localhost',
}

const getNonce = () => {
  const meta: HTMLElement | null = document.querySelector('meta[property="csp-nonce"]');
  const nonce = meta?.nonce;
  return nonce ?? '';
};

const resolveApiBaseUrl = (): string => {
  // In local dev we point the app at its own origin so requests flow through the Vite proxy
  // (see vite.config.ts). That keeps the app and API same-origin, so the HttpOnly refresh-token
  // cookie is first-party and is sent on /refresh. Deployed builds use VITE_OIR_BASE_URL, where
  // the frontend and backend are already served from the same origin.
  if (import.meta.env.DEV) {
    return globalThis.location.origin;
  }

  return (import.meta.env.VITE_OIR_BASE_URL as string | undefined) ?? 'http://localhost:8080';
};

export const appConfig = {
  api: {
    baseUrl: resolveApiBaseUrl(),
  },
  thirdParties: {
    pendoApiKey: (import.meta.env.VITE_PENDO_API_KEY as string | undefined) ?? '',
    agGridLicenseKey: (import.meta.env.VITE_AG_GRID_LICENSE_KEY as string | undefined) ?? '',
    newRelic: {
      enabled: (import.meta.env.VITE_NEW_RELIC_ENABLED as string | undefined) === 'true',
      licenseKey: (import.meta.env.VITE_NEW_RELIC_LICENSE_KEY as string | undefined) ?? '',
      applicationId: (import.meta.env.VITE_NEW_RELIC_APPLICATION_ID as string | undefined) ?? '',
      accountId: (import.meta.env.VITE_NEW_RELIC_ACCOUNT_ID as string | undefined) ?? '',
      agentId: (import.meta.env.VITE_NEW_RELIC_AGENT_ID as string | undefined) ?? '',
      trustKey: (import.meta.env.VITE_NEW_RELIC_TRUST_KEY as string | undefined) ?? '',
    },
  },
  environment: Object.values(Environment).includes(import.meta.env.VITE_ENVIRONMENT as Environment)
    ? (import.meta.env.VITE_ENVIRONMENT as Environment)
    : Environment.LOCALHOST,
  cspNonce: getNonce(),
};
